import React from 'react';
import { Typography } from '@mui/material';

type ErrorFormMessageProps = {
  errorMessage?: string;
};

export const ErrorFormMessage: React.FC<ErrorFormMessageProps> = ({ errorMessage }) => (
  <Typography
    sx={{
      color: 'var(--color-red)',
      fontSize: '14px',
      marginTop: '4px',
    }}
  >
    {errorMessage}
  </Typography>
);
